module.exports = "<div class=\"container\" *ngIf=\"dataLoaded\">\r\n  <div class=\"row\" *ngFor=\"let data of privacyPolicy\">\r\n    <div class=\"col-md-12 col-sm-12 col-12\">\r\n      <h3 class=\"title\">{{data.title}}</h3><br>\r\n      <div [innerHTML]=\"data.content\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/privacy-policy/privacy-policy.component.html
// module id = 677
// module chunks = 8